import React, { useState } from "react";
import { AlertCircle } from "lucide-react";
import { Field, Input } from "../components/UI";
import { useAuth, USERS, ROLE_LABELS } from "../contexts/AuthContext";
import { useToast } from "../components/Toast";
import { authAPI } from "../utils/api";

const LoginPage = () => {
  const { login } = useAuth();
  const { toast } = useToast();
  const [form, setForm]   = useState({ username:"", password:"" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.username || !form.password) return;
    setLoading(true); setError("");
    try {
      const res = await authAPI.login({ username: form.username, password: form.password });
      localStorage.setItem('ifms_token', res.token);
      const u = res.user;
      toast(`Selamat datang, ${u.name} (${ROLE_LABELS[u.role] || u.role})`, "success");
      login(u);
    } catch(e) { setError(e.message || "Login gagal"); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:"100vh", background:"linear-gradient(135deg,#0F172A 0%,#1E3A5F 50%,#0F172A 100%)",
      display:"flex", alignItems:"center", justifyContent:"center", padding:"0 20px", fontFamily:"'Inter',sans-serif" }}>
      <div style={{ width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <img src="/logo-rspad.png" alt="RSPAD Gatot Soebroto"
            style={{ width:96, height:96, objectFit:"contain", marginBottom:12,
              filter:"drop-shadow(0 4px 16px rgba(0,0,0,0.5))" }}/>
          <h1 style={{ color:"white", fontSize:22, fontWeight:800, margin:0, letterSpacing:"-0.02em" }}>
            IFMS
          </h1>
          <p style={{ color:"#CBD5E1", fontSize:12, fontWeight:600, margin:"4px 0 2px", letterSpacing:"0.06em", textTransform:"uppercase" }}>
            RSPAD Gatot Soebroto
          </p>
          <p style={{ color:"#64748B", fontSize:11, margin:0 }}>
            Sistem Informasi Manajemen Program &amp; Anggaran
          </p>
        </div>
        <div style={{ background:"white", borderRadius:20, padding:32, boxShadow:"0 24px 64px rgba(0,0,0,0.3)" }}>
          <h2 style={{ fontSize:18, fontWeight:700, color:"#111827", margin:"0 0 24px" }}>Masuk ke Sistem</h2>
          {error && (
            <div style={{ background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, padding:"10px 14px",
              marginBottom:16, color:"#DC2626", fontSize:13, display:"flex", alignItems:"center", gap:8 }}>
              <AlertCircle size={16}/> {error}
            </div>
          )}
          <Field label="Username">
            <Input value={form.username} onChange={e=>setForm({...form,username:e.target.value})} placeholder="Masukkan username"/>
          </Field>
          <div style={{ marginBottom:24 }}>
            <Field label="Password">
              <Input value={form.password} onChange={e=>setForm({...form,password:e.target.value})}
                type="password" placeholder="Masukkan password"
                onKeyDown={e=>e.key==="Enter"&&handleSubmit()}/>
            </Field>
          </div>
          <button onClick={handleSubmit} disabled={loading}
            style={{ width:"100%", padding:12, background:loading?"#9CA3AF":"linear-gradient(135deg,#2563EB,#1D4ED8)",
              color:"white", border:"none", borderRadius:10, fontSize:15, fontWeight:600,
              cursor:loading?"not-allowed":"pointer" }}>
            {loading?"Memproses…":"Masuk"}
          </button>
          <div style={{ marginTop:24, paddingTop:20, borderTop:"1px solid #F3F4F6" }}>
            <p style={{ fontSize:11, color:"#9CA3AF", textAlign:"center", marginBottom:10, fontWeight:500 }}>AKSES CEPAT (DEMO)</p>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
              {USERS.map(u=>(
                <button key={u.id} onClick={()=>setForm({username:u.username,password:u.password})}
                  style={{ padding:8, background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:8,
                    cursor:"pointer", textAlign:"left", fontFamily:"inherit" }}
                  onMouseEnter={e=>e.target.style.background="#EFF6FF"}
                  onMouseLeave={e=>e.target.style.background="#F8FAFC"}>
                  <div style={{ fontSize:11, fontWeight:700, color:"#1E40AF" }}>{u.username}</div>
                  <div style={{ fontSize:10, color:"#6B7280" }}>{u.role}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
